type InsuranceLiability = {
  damage?: number | null;
  theft?: number | null;
};

export type InsuranceCondition = {
  description?: string | null;
  id: string;
};

type InsurancePrice = {
  includingVat?: number | null;
  excludingVat?: number | null;
};

type InsuranceProduct = {
  durationInYears?: number | null;
  id: string;
  insuranceType: 'INSURANCE' | 'EXTENDED_WARRANTY';
  isRecommended?: boolean | null;
  paymentType: string;
  premium?: InsurancePrice | null;
  salesPrice?: InsurancePrice | null;
  title?: string | null;
  usps?: string[] | null;
  yearlyPremium?: InsurancePrice | null;
};

type InsuranceIcon =
  | 'THIEF'
  | 'DAMAGE'
  | 'DROPLET'
  | 'WRENCH'
  | 'LIGHTNING'
  | 'TRUCK_SMALL'
  | 'MONEY';

export type InsuranceAttribute = {
  icon?: InsuranceIcon | null;
  description?: string | null;
  id: string;
  name?: string | null;
};

type InsurancePackage = {
  attributes?: InsuranceAttribute[] | null;
  conditions?: InsuranceCondition[] | null;
  isRecommended?: boolean | null;
  liability?: InsuranceLiability | null;
  products?: InsuranceProduct[] | null;
  prosAndCons?: {
    cons: string[] | null;
    pros: string[] | null;
  } | null;
  title?: string | null;
  usps?: string[] | null;
};

type InsurancePackageSummary = {
  conditions?: InsuranceCondition[] | null;
  liability?: InsuranceLiability | null;
  liabilityCondition?: InsuranceCondition | null;
  optionalAttributes?: InsuranceAttribute[] | null;
  requiredAttributes?: InsuranceAttribute[] | null;
};

export type Insurance = {
  description?: string | null;
  documents?: {
    insuranceCardUrl?: string | null;
    termsAndConditionsUrl?: string | null;
  } | null;
  packages?: InsurancePackage[] | null;
  summary?: InsurancePackageSummary | null;
};

export enum InsuranceProvider {
  ERGO = 'ERGO',
  CoverGenius = 'CoverGenius'
}
